import { BackgroundImage, Button, Center } from "@mantine/core";
import { modals } from "@mantine/modals";

import SRD_Form from "components/Form";
import { useNavigate, useLocation } from "react-router-dom";
import { insertUserInfo } from "../apis/adminUserApis";

import { groupListState } from "components/Form/atom/groupListState";
import { levelListState } from "components/Form/atom/levelListState";
import { userState } from "pages/Login/atom/userState";
import { useRecoilState } from "recoil";

function UserAddForm() {

  const [user, setUser] = useRecoilState(userState);
  const level = Number(user?.fn_level);
  const [groupList, setGroupList] = useRecoilState(groupListState);
  const [initLevelList, setInitLevelList] = useRecoilState(levelListState);
  const userLevelList = initLevelList.filter(item => Number(item.value) >= level);

  const location = useLocation();
  let backPage = 1;
  let backGroup;
  if (location.state) {
    backPage = location.state.pg;
    backGroup = location.state.group;
  }

  const backToList = () => {
    const params = new URLSearchParams({page: String(backPage)});
    if (backGroup !== undefined && backGroup !== null) {
      params.set("group", backGroup);
    }
    navigate(`/admin/user?${params.toString()}`, {replace: true});
  };

  const navigate = useNavigate();
  const fields = [
    {
      key: "user_id",
      name: "아이디",
      type: "id",
      disabled: false, // disabled 속성을 false로 설정하여 수정 가능하게 함
    },
    {
      key: "password",
      name: "비밀번호",
      type: "password",
      disabled: false, // disabled 속성을 false로 설정하여 수정 가능하게 함
    },
    {
      key: "confirm_password",
      name: "비밀번호 확인",
      type: "confirm_password",
    },
    { key: "fn_name", name: "이름", type: "text",options:"validate", },
    {
      key: "fn_level",
      name: "사용자레벨",
      type: "select",
      options: userLevelList,
    },
    {
      key: "fn_group_nm",
      name: "소속그룹",
      type: "select",
      options: groupList,
    },
    { key: "fn_mobile_nbr", name: "전화번호", type: "phone_number" },
    { key: "fn_address", name: "주소", type: "text" },
  ];

  const onSubmit = (e) => {
    modals.openConfirmModal({
      title: "저장",
      children: <Center>저장 하시겠습니까?</Center>,
   //   centered: true,
      zIndex: 2000,
      labels: { confirm: "저장", cancel: "취소" },
      onConfirm: () => {
        insertUserInfo(e);
        backToList();
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Button type="submit">저장</Button>
      </Center>
    );
  };

  return (
    <>
      <SRD_Form fields={fields} onSubmit={onSubmit} submitButton={<SubmitButton />} />
    </>
  );
}

export default UserAddForm;
